// Casa os TEXTOS do catálogo com os SELETORES do módulo, por índice.
//
// Puro de propósito: é a junta mais frágil do tour guiado (duas fontes de dado
// que evoluem em repositórios diferentes), e uma função sem Vue/Vuex/API é a
// única forma de testá-la sem montar tela.
//
// O central-config não conhece nenhum módulo: quem passa o mapa é o consumidor.

// Divergência de contagem não trava o tour — passo sem seletor cai no balão
// centralizado, que é degradação aceitável. Mas é erro de configuração, e
// avisar alto em dev é o que evita degradar em silêncio até alguém reclamar.
// (Mesma postura de `warnOnTourConfigMismatch` no whatsnew-tour-mixin.)
const avisarDivergencia = (slug, instrucoes, passos) => {
  // eslint-disable-next-line no-console
  console.warn(
    `[tour-guiado] "${slug}": ${instrucoes} instrução(ões) no catálogo x ${passos} passo(s) mapeado(s) — devem ser 1:1. Rode "npm run trilhas:snapshot" e reveja o mapa do módulo.`
  )
}

/**
 * @param {Object} task    etapa do catálogo (com metadata.instructions[])
 * @param {Array}  mapa    lista de { alvo, avancaNoClique, aguarda, semAlvo }
 * @returns {Array} passos prontos para o GuidedTourHost
 */
export function montarPassosDoTour({ task, mapa } = {}) {
  const metadata = (task && task.metadata) || {}
  const instrucoes = metadata.instructions || []
  const seletores = mapa || []

  if (!instrucoes.length) return []

  if (seletores.length && seletores.length !== instrucoes.length) {
    avisarDivergencia(
      (task && task.slug) || 'etapa sem slug',
      instrucoes.length,
      seletores.length
    )
  }

  return instrucoes.map((instrucao, indice) => {
    const doMapa = seletores[indice] || {}
    return {
      titulo: (instrucao && instrucao.title) || '',
      detalhe: (instrucao && instrucao.detail) || '',
      alvo: doMapa.alvo || null,
      // Alvo que só existe depois de o usuário abrir algo (um modal). Enquanto
      // não existir, o passo fica ancorado no `alvo` — que costuma ser o botão
      // que o abre. Ver o passo "Importe a planilha" do Fee Fixo.
      alvoAoAbrir: doMapa.alvoAoAbrir || null,
      // Só é false quando o mapa diz explicitamente; o default é avançar no
      // clique (modo híbrido).
      avancaNoClique: doMapa.avancaNoClique !== false,
      aguarda: doMapa.aguarda || null,
      // Canal do GlobalBus que CONCLUI o passo. Existe para a ação que não
      // termina num clique no alvo: subir uma planilha começa no clique da
      // dropzone e só acaba quando o arquivo foi aceito e gravado. Sem isto o
      // usuário faz a coisa toda e o tour continua pedindo que ele a faça.
      avancaEm: doMapa.avancaEm || null,
      // "Próximo" pode FAZER a abertura que o passo pede, quando ela ainda não
      // foi feita — senão o balão anda e a tela fica para trás, e cada passo
      // seguinte descreve algo que não está na frente do usuário.
      //
      // ⚠️ Só abrir/expandir/navegar (decisão do owner, 14/08). O mapa NUNCA
      // marca ação que grave, baixe ou encerre: tour que confirma importação ou
      // encerra um ensaio por conta própria assusta mais do que ajuda.
      abreNoProximo: doMapa.abreNoProximo === true,
    }
  })
}

/**
 * A próxima etapa guiável: a primeira PENDENTE, na ordem visual, que tenha
 * entrada no mapa do módulo. O mapa é o gate do escopo — sem isso o desfecho
 * ofereceria guiar uma etapa sem seletores, e o usuário cairia num tour de
 * balões centralizados.
 *
 * @param {Array}    etapas    etapas já visíveis e ordenadas (do consumidor)
 * @param {Function} temTour   (slug) => Boolean
 * @param {String}   slugAtual etapa recém-concluída, sempre pulada
 */
export function proximaEtapaGuiavel({ etapas, temTour, slugAtual } = {}) {
  const lista = etapas || []
  const guiavel = typeof temTour === 'function' ? temTour : () => false
  return (
    lista.find((etapa) => etapaEhGuiavel(etapa, slugAtual, guiavel)) || null
  )
}

function etapaEhGuiavel(etapa, slugAtual, guiavel) {
  if (!etapa || !etapa.slug) return false
  if (etapa.slug === slugAtual) return false
  if (etapa.isDone) return false
  // Etapa cuja tela o escritório não contratou: navegar levaria a 404.
  if (etapa.isIndisponivel) return false
  return guiavel(etapa.slug)
}
